<template lang="html">
  <div id="projects-page">

    <section class="container oversized-container projects-section">
      <h2 class="common-title">{{ $t("shared.titles.projects") }}</h2>

      <div class="row">
        <div class="col-md-6 col-lg-4 col-project-sample" v-for="(project, pjInx) in projects" :key="pjInx">
          <router-link class="pj-link" :to="'/proyectos/categoria/'+project.id">

            <div class="placed-backg box-img" v-bind:style="{ backgroundImage: 'url('+project.image+')' }">
              <img src="public/images/pages/home/p-empty.png">
            </div>
            <div class="box-info">
                <h5>{{ project.name }}</h5>
            </div>
          </router-link>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{
      projects: [
        /*{ id: 1, image: 'public/images/pages/home/project-1.jpg', name: 'Hoteles', },
        { id: 2, image: 'public/images/pages/home/project-2.jpg', name: 'Edificios', },
        { id: 3, image: 'public/images/pages/home/project-3.jpg', name: 'Residencias', },
        { id: 3, image: 'public/images/pages/home/project-3.jpg', name: 'Residencias', },
        { id: 1, image: 'public/images/pages/home/project-1.jpg', name: 'Hoteles', },
        { id: 2, image: 'public/images/pages/home/project-2.jpg', name: 'Edificios', },*/
      ],
    }
  },
  methods: {
      getCategoriesProjects: function(){
        axios.get(tools.url('/categoriesFrontProjects')).then(
          ({data}) =>{
            this.projects=data;
          });
      },

  },
  mounted() {
      this.getCategoriesProjects();

  }
}
</script>
